import { filter, mapTo } from "rxjs/operators";
import { selectSelectedBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsDeselect } from "../../player-base/buildings/actionBuildings";
import { QuickSellSwapSupportedModals } from "../QuickSellResourceConfig";
export var epicQuickSellClose = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return quickSellCloseFilter(action, state$.value);
    }), mapTo(actionBuildingsDeselect()));
};
export var quickSellCloseFilter = function (action, state) {
    var isBuildingSelected = !!selectSelectedBuildingInfo(state);
    if (!isBuildingSelected) {
        return false;
    }
    var isQuickSellClosed = action.type === TypeActionModal.Close && action.modalId === IdModal.QuickSell;
    var isQuickSellSwapped = action.type === TypeActionModal.SwapLast &&
        QuickSellSwapSupportedModals.some(function (val) { return val === action.modalId; });
    var isModalStackEmptyOnCloseLast = action.type === TypeActionModal.CloseLast && action.modalId === IdModal.QuickSell;
    return isQuickSellClosed || isQuickSellSwapped || isModalStackEmptyOnCloseLast;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/epics/epicQuickSellClose.ts
// module id = 2110
// module chunks = 3